import config from "../config";

/**
 * LaunchDarkly gate for configuration help (`support-agent`).
 *
 * The flag is evaluated on the same user context the rest of the app sends.
 * With the flag off, the configuration help panel is not shown.
 */
const SUPPORT_AGENT_FLAG_KEYS = ["support-agent", "supportAgent", "supportagent"];

function isLdFlagEnabled(flags: Record<string, unknown>, ...keys: string[]): boolean {
  for (const key of keys) {
    const value = flags[key];
    if (value === true) return true;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      if (normalized === "true" || normalized === "on" || normalized === "yes" || normalized === "1") {
        return true;
      }
    }
  }
  return false;
}

export function isSupportAgentLdEnabled(flags: Record<string, unknown>): boolean {
  // No client-side id means no flags at all, so local development would lose the panel
  // entirely rather than have it switched off. Same exception the other product flags make.
  if (process.env.NODE_ENV === "development" && !config.launchdarklyClientSideId) {
    return true;
  }
  return isLdFlagEnabled(flags, ...SUPPORT_AGENT_FLAG_KEYS);
}
